import { Marker, Popup } from 'react-leaflet';

import { useGeoLocation } from '@/hooks/useGeoLocation';
import { useTranslation } from 'react-i18next';

import './YouAreHere.css';

export function YouAreHere() {
  const position = useGeoLocation();
  const { t } = useTranslation();

  if (!position) return null;

  return (
    <Marker position={position}>
      <Popup className="popup-for-your-position">{t('map.youAreHere.text')}</Popup>
    </Marker>
  );
}
